import script from "./SurveyRelationsRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./SurveyRelationsRow.vue?vue&type=script&lang=ts&setup=true"

import "./SurveyRelationsRow.vue?vue&type=style&index=0&id=75706e2c&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75706e2c"]])

export default __exports__